"use client"

import { useState } from "react"

const VisaForm = ({ onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    item_name: "",
    description: "",
    quantity: 1,
    cost_price: 0,
    selling_price: 0,
    margin: 0,
    item_type: "visa",
    // Visa specific fields
    visa_type: "",
    destination_country: "",
    applicant_name: "",
    passport_number: "",
    nationality: "",
    processing_time: "",
    visa_duration: "",
    entry_type: "single",
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => {
      const updated = { ...prev, [name]: value }

      // Auto-calculate margin and total when prices change
      if (name === "cost_price" || name === "selling_price") {
        const costPrice = Number.parseFloat(name === "cost_price" ? value : updated.cost_price) || 0
        const sellingPrice = Number.parseFloat(name === "selling_price" ? value : updated.selling_price) || 0

        if (costPrice > 0) {
          updated.margin = Math.round(((sellingPrice - costPrice) / costPrice) * 100)
        }
        updated.total_amount = sellingPrice * updated.quantity
      }

      if (name === "quantity") {
        updated.total_amount = updated.selling_price * Number.parseInt(value)
      }

      return updated
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  return (
    <form onSubmit={handleSubmit} className="item-form">
      <div className="form-grid">
        <div className="form-group">
          <label>Item Name *</label>
          <input
            type="text"
            name="item_name"
            value={formData.item_name}
            onChange={handleInputChange}
            placeholder="e.g., UAE Tourist Visa"
            required
          />
        </div>

        <div className="form-group">
          <label>Visa Type *</label>
          <select name="visa_type" value={formData.visa_type} onChange={handleInputChange} required>
            <option value="">Select Visa Type</option>
            <option value="tourist">Tourist Visa</option>
            <option value="business">Business Visa</option>
            <option value="transit">Transit Visa</option>
            <option value="work">Work Visa</option>
            <option value="student">Student Visa</option>
            <option value="family">Family Visa</option>
          </select>
        </div>

        <div className="form-group">
          <label>Destination Country *</label>
          <input
            type="text"
            name="destination_country"
            value={formData.destination_country}
            onChange={handleInputChange}
            placeholder="e.g., United Arab Emirates"
            required
          />
        </div>

        <div className="form-group">
          <label>Applicant Name *</label>
          <input
            type="text"
            name="applicant_name"
            value={formData.applicant_name}
            onChange={handleInputChange}
            placeholder="Full name as per passport"
            required
          />
        </div>

        <div className="form-group">
          <label>Passport Number *</label>
          <input
            type="text"
            name="passport_number"
            value={formData.passport_number}
            onChange={handleInputChange}
            placeholder="Passport number"
            required
          />
        </div>

        <div className="form-group">
          <label>Nationality *</label>
          <input
            type="text"
            name="nationality"
            value={formData.nationality}
            onChange={handleInputChange}
            placeholder="e.g., Pakistani"
            required
          />
        </div>

        <div className="form-group">
          <label>Processing Time</label>
          <select name="processing_time" value={formData.processing_time} onChange={handleInputChange}>
            <option value="">Select Processing Time</option>
            <option value="normal">Normal (5-7 days)</option>
            <option value="express">Express (2-3 days)</option>
            <option value="urgent">Urgent (24 hours)</option>
          </select>
        </div>

        <div className="form-group">
          <label>Visa Duration</label>
          <select name="visa_duration" value={formData.visa_duration} onChange={handleInputChange}>
            <option value="">Select Duration</option>
            <option value="14_days">14 Days</option>
            <option value="30_days">30 Days</option>
            <option value="60_days">60 Days</option>
            <option value="90_days">90 Days</option>
            <option value="1_year">1 Year</option>
          </select>
        </div>

        <div className="form-group">
          <label>Entry Type *</label>
          <select name="entry_type" value={formData.entry_type} onChange={handleInputChange} required>
            <option value="single">Single Entry</option>
            <option value="multiple">Multiple Entry</option>
          </select>
        </div>

        <div className="form-group">
          <label>Quantity *</label>
          <input
            type="number"
            name="quantity"
            value={formData.quantity}
            onChange={handleInputChange}
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label>Cost Price *</label>
          <input
            type="number"
            name="cost_price"
            value={formData.cost_price}
            onChange={handleInputChange}
            step="0.01"
            min="0"
            required
          />
        </div>

        <div className="form-group">
          <label>Selling Price *</label>
          <input
            type="number"
            name="selling_price"
            value={formData.selling_price}
            onChange={handleInputChange}
            step="0.01"
            min="0"
            required
          />
        </div>
      </div>

      <div className="form-group full-width">
        <label>Description</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          placeholder="Additional details about the visa application..."
          rows="3"
        />
      </div>

      <div className="pricing-summary">
        <div className="summary-item">
          <span>Margin: {formData.margin}%</span>
        </div>
        <div className="summary-item">
          <span>Total Amount: ${(formData.selling_price * formData.quantity).toFixed(2)}</span>
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn-primary">
          Add Visa Application
        </button>
      </div>
    </form>
  )
}

export default VisaForm
